const { getProperty } = require('../../util/PropertyGetter');

function getViewStateFlags(data) {
  const product = getProperty(data, 'product', {});
  const viewState = getProperty(data, 'viewState', {});
  const featureEligible = getProperty(data, 'featureEligible', {});

  const unavailableConsolidatedUpc = !!(getProperty(product, 'detail.flags.consolidatedProductComplex') && !getProperty(data, 'viewState.detail.selectedUpcItem'));
  const hasOffers = !!getProperty(viewState, 'offers.lists.topOffers.length');

  const viewStateFlags = {
    klarna: featureEligible.klarna && viewState.klarna.isWithinRange,
    offerLayout: !unavailableConsolidatedUpc && (hasOffers || featureEligible.klarna || featureEligible.creditFinance),
    priceExpPrice: featureEligible.priceExpPrice && !unavailableConsolidatedUpc,
    unavailableConsolidatedUpc,
  };

  return viewStateFlags;
}

module.exports = {
  getViewStateFlags,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/viewState/ViewStateUtil.js